// Centralized action enum for gesture and scroller actions
// Keeps string values stable for consumers that expect these literals
export const Action = Object.freeze({
  START: 'start',
  PLAY: 'play',
  PAUSE: 'pause',
  STOP: 'stop',
  NEXT: 'next',
  PREV: 'prev',
});

export const ALL_ACTIONS = Object.freeze([
  Action.START,
  Action.PLAY,
  Action.PAUSE,
  Action.STOP,
  Action.NEXT,
  Action.PREV,
]);

// Tiny helper to validate an action string
export function isAction(val) {
  return typeof val === 'string' && ALL_ACTIONS.includes(val);
}
